import * as React from "react";
function PopoutIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px",
    "data-rtl-flip": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.001 7.498V.748a.75.75 0 0 0-.75-.75h-6.75a.75.75 0 0 0 0 1.5h6.75l-.75-.75v6.75a.75.75 0 0 0 1.5 0m-1.28-7.28-15 15a.75.75 0 1 0 1.06 1.06l15-15a.75.75 0 0 0-1.06-1.06m-11.47 4.28h-9a2.25 2.25 0 0 0-2.25 2.25v15a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-9a.75.75 0 0 0-1.5 0v9a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h9a.75.75 0 0 0 0-1.5"
  }));
}
export default PopoutIcon;